import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import useTranslation from "../../hooks/traslation";
import { GRAPH_TYPE } from "../../utils/enums";
import { useEffect, useState } from "react";
import { useLazyGetEmployeGraphQuery } from "../../services/dashboard";
import { showError } from "../../constants/toasts";

const CustomerGraph = () => {
  const translation = useTranslation();
  const [getEmpolyeGraph] = useLazyGetEmployeGraphQuery();
  const [isEmployeLoading, setIsEmployeLoading] = useState(false);
  const [empolyeGraphType, setEmpolyeGraphType] = useState(GRAPH_TYPE.DAY);
  const [employeData, setEmployeData] = useState([]);

  const EmployeGraph = async () => {
    setIsEmployeLoading(true);
    try {
      const response = await getEmpolyeGraph({
        type: empolyeGraphType,
      }).unwrap();
      if (response?.statusCode === 200) {
        setEmployeData(response?.data || []);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    } finally {
      setIsEmployeLoading(false);
    }
  };
  const handleEmployeGraphTypeChange = (type: GRAPH_TYPE) => {
    setEmpolyeGraphType(type);
    // EmployeGraph();
  };
  useEffect(() => {
    EmployeGraph();
  }, [empolyeGraphType]);
  return (
    <>
      <div className="cards table_card">
        <div className="cards_header">
          <div className="left_s">
            <h2>{translation.main.totalEmployer}</h2>
          </div>
          <div className="right_s">
            <p>
              <span
                className={`time-period ${
                  empolyeGraphType === GRAPH_TYPE.DAY ? "active" : ""
                }`}
                onClick={() => handleEmployeGraphTypeChange(GRAPH_TYPE.DAY)}
              >
                {translation.main.aday.charAt(0).toUpperCase() +
                  translation.main.aday.slice(1).toLowerCase()}
              </span>
              <span
                className={`time-period ${
                  empolyeGraphType === GRAPH_TYPE.WEEK ? "active" : ""
                }`}
                onClick={() => handleEmployeGraphTypeChange(GRAPH_TYPE.WEEK)}
              >
                {translation.main.aweek.charAt(0).toUpperCase() +
                  translation.main.aweek.slice(1).toLowerCase()}
              </span>
              <span
                className={`time-period ${
                  empolyeGraphType === GRAPH_TYPE.MONTH ? "active" : ""
                }`}
                onClick={() => handleEmployeGraphTypeChange(GRAPH_TYPE.MONTH)}
              >
                {translation.main.amonth.charAt(0).toUpperCase() +
                  translation.main.amonth.slice(1).toLowerCase()}
              </span>
              <span
                className={`time-period ${
                  empolyeGraphType === GRAPH_TYPE.YEAR ? "active" : ""
                }`}
                onClick={() => handleEmployeGraphTypeChange(GRAPH_TYPE.YEAR)}
              >
                {translation.main.ayear.charAt(0).toUpperCase() +
                  translation.main.ayear.slice(1).toLowerCase()}
              </span>
            </p>
          </div>
        </div>
        <div className="graph-container">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={employeData}
              style={{ fontSize: 15 }}
              margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 60,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="name"
                angle={-45}
                textAnchor="end"
                height={60}
                interval={0}
                tick={{ fontSize: 12 }}
                tickFormatter={(value) => {
                  if (typeof value === "string") {
                    return (
                      value.charAt(0).toUpperCase() +
                      value.slice(1).toLowerCase()
                    );
                  }
                  return value;
                }}
              />
              <YAxis tick={{ fontSize: 12 }} width={80} />
              <Tooltip
                contentStyle={{
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  fontSize: "12px",
                }}
              />
              <Bar
                dataKey="value"
                fill="#BF2F17"
                radius={[4, 4, 0, 0]}
                barSize={40}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </>
  );
};

export default CustomerGraph;
